import React, {useEffect} from 'react';
import {CSSTransition} from "react-transition-group";

import styles from "./FilterMobile.module.scss";
import CloseImg from '../../assets/images/btn_close_dark.png';

const FilterNavigationMobile = ({ offersCategories, isOpen, setIsOpen }) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <>
            <CSSTransition in={isOpen} timeout={300} classNames="fade-in-slide-up" unmountOnExit>
                <div className={`${styles.filtersWrapper} ${isOpen ? 'open' : ''}`}>
                    {offersCategories.map((category, index) => {
                        return (
                            <div key={index} className={styles.categoryWrapper}
                                 onClick={() => {
                                     // because, when the filter is open
                                     // there is no such element
                                     setTimeout(() => {
                                         document.getElementById(category.order).scrollIntoView({behavior: "smooth"});
                                     }, 500);
                                     setIsOpen(false);
                                 }}>
                                <img src={category.icon} className={styles.categoryFilterImg} alt={category.name}/>
                            </div>)
                    })}
                    <div className={styles.buttonClose} onClick={() => setIsOpen(false)}>
                        <img className={styles.closeImg} src={CloseImg} alt='close' />
                        <span>閉じる</span>
                    </div>
                </div>
            </CSSTransition>
        </>
    );
};

export default FilterNavigationMobile;